import {
  createFeatureSelector,
  MemoizedSelector,
  createSelector
} from '@ngrx/store';
import { SearchResultModel } from 'datastop-io-autocomplete-library-1/lib/models/search/search-result.model';
import {
  OccupationQuickMatchModel,
  LocationModel
} from '@cpd-app/core-module/models';

import * as LocationFeatureState from './location.state';

// RETRIEVE LOCATION SLICE OF STATE
export const locationStateSlice: MemoizedSelector<
  object,
  LocationFeatureState.LocationState
> = createFeatureSelector<LocationFeatureState.LocationState>(
  LocationFeatureState.locationFeatureKey
);

// GET LOCATION MODEL
export const getLocationModel: MemoizedSelector<object, LocationModel> =
  createSelector(
    locationStateSlice,
    (state): LocationModel => state.locationModel
  );

// GET SEARCH RESULT MODEL
export const getSearchResultModel: MemoizedSelector<object, SearchResultModel> =
  createSelector(locationStateSlice, (state): SearchResultModel => {
    if (state.locationModel) {
      return {
        id: state.locationModel.zipCode,
        name: `${state.locationModel.cityName}`,
        data: null
      };
    }

    return null;
  });

// RETRIEVE LIST OF OCCUPATIONS
export const getOccupationList: MemoizedSelector<
  object,
  OccupationQuickMatchModel[]
> = createSelector(locationStateSlice, LocationFeatureState.selectAll);
